import React from 'react';
import { PropTypes as PT } from 'prop-types';
import Measure from 'react-measure';
import classes from './CallVideo.module.scss';

const CallVideo = (props) => {
  const {
    hasVideo,
    videoElementId,
    isMinimized,
    videoWidth,
    videoContainerWidth,
    onResizeVideo,
    updateVideoRatio,
  } = props;

  if (!hasVideo) return <div />;

  return (
    <div
      className={classes.videoContainer}
      style={{ width: isMinimized ? '100%' : videoContainerWidth }}
    >
      <Measure
        bounds
        onResize={contentRect => onResizeVideo(videoElementId, contentRect.bounds)}
      >
        {({ measureRef }) =>
          <video
            ref={measureRef}
            className={classes.video}
            id={videoElementId}
            onLoadedData={() => updateVideoRatio(videoElementId)}
            style={{ width: isMinimized ? '100%' : videoWidth }}
          />
        }
      </Measure>
    </div>
  );
};

CallVideo.propTypes = {
  hasVideo: PT.bool.isRequired,
  isMinimized: PT.bool.isRequired,
  videoElementId: PT.string.isRequired,
  updateVideoRatio: PT.func,
  onResizeVideo: PT.func,
  videoWidth: PT.number,
  videoContainerWidth: PT.number,
};

export default CallVideo;
